import { ILandingPagesBuilderSchema } from '@playbook-technologies/common-schemas';
import { defaultFeatures } from './OTPFeaturesSection';
import { toImgSrcRaw, toVideoSrcRaw } from './helpers';
import { defaultReviews, defaultFaqs } from './helpers';
import {
  defaultSubscriptionPageConfig,
  inheritedSectionFromCreatorLanding,
} from '@playbook-technologies/common-schemas/lib/schemas/defaultSubCustomProgramPage';
import { extendSectionsType } from './mapper';

export function defaultOTPPageConfig(
  program,
  {
    primaryColor,
    colors,
    landingPageConfig,
  }: {
    primaryColor: string;
    colors: string[];
    landingPageConfig: ILandingPagesBuilderSchema | null;
  },
) {
  const inheritedSections = inheritedSectionFromCreatorLanding(
    landingPageConfig,
    {
      primaryColor,
    },
  );

  return {
    sections: [
      {
        enabled: true,
        type: 'Introduction',
        title: program.name,
        subtitle: '',
        desc: '',
        coverImage: toImgSrcRaw(program?.mediaCover),
        introVideo: toVideoSrcRaw(program?.mediaIntro),
        primaryColor,
        logo: landingPageConfig?.branding.logo,
        colorIndex: 1,
        bgColor: colors[1],
        priceBefore: null,
      },
      {
        type: 'EmailCapture',
        enabled: false,
        bgColor: colors[2],
        colorIndex: 2,
        title: '',
        description: '',
        displayAsPopup: true,
      },
      {
        enabled: true,
        colorIndex: 0,
        bgColor: colors[0],
        type: 'EmailCapture',
        title: '',
        description: '',
        image: null,
      },
      {
        enabled: true,
        type: 'ProgramStats',
        bgColor: colors[2],
        colorIndex: 2,
      },
      {
        enabled: true,
        type: 'TextSection1',
        title: 'About the program',
        desc: program.description ?? '',
        coverImage: toImgSrcRaw(program?.mediaCover),
        introVideo: toVideoSrcRaw(program?.mediaIntro),
        colorIndex: 2,
        bgColor: colors[2],
      },
      {
        enabled: true,
        type: 'Workouts',
        title: 'Workouts',
        bgColor: colors[2],
        colorIndex: 2,
        workoutIds: [],
      },
      inheritedSections['Reviews'] ?? {
        enabled: true,
        type: 'Reviews',
        title: 'Glowing 5-Star Reviews from Satisfied Customers',
        reviews: [...defaultReviews],
        bgColor: colors[1],
        colorIndex: 1,
      },
      inheritedSections['Testimonials'] ?? {
        enabled: true,
        type: 'Testimonials',
        title: 'Need to see it to believe?',
        testimonials: parseProgramTestimonials(program),
        bgColor: colors[0],
        colorIndex: 0,
      },
      {
        enabled: true,
        type: 'OTPFeatures',
        title: 'Program Features',
        bgColor: colors[1],
        colorIndex: 1,
        features: defaultFeatures,
      },
      inheritedSections['Bio'] ?? {
        enabled: true,
        type: 'Bio',
        title: program.influencer.bio || 'Online personal trainer',
        desc: program.influencer?.messageProfile || '',
        coverImage: toImgSrcRaw(program.influencer.mediaAvatar),
        bgColor: colors[0],
        colorIndex: 0,
        introVideo: null,
      },
      {
        enabled: true,
        type: 'TextSection2',
        title: 'Get support & accountability from our amazing community',
        desc:
          program.influencer.messageCommunity ||
          `Find encouragement and accountability by connecting with others in our exclusive private community. There you can learn about nutrition, learn more about form, and connect with other members. Bonus: ${program.influencer.firstName} will be right there to cheer on you.`,
        images: [],
        bgColor: colors[0],
        colorIndex: 0,
      },
      {
        enabled: true,
        type: 'TextSection2',
        title: 'Bonus material',
        desc: '',
        bullets: [],
        images: [],
        rotateImages: true,
        bgColor: colors[1],
        colorIndex: 1,
      },
      inheritedSections['FAQs'] ?? {
        enabled: true,
        type: 'FAQs',
        title: 'Frequently asked questions',
        faqs: [...(program.faq?.length ? program.faq : defaultFaqs)],
        bgColor: colors[2],
        colorIndex: 2,
      },
    ],
  };
}

export function loadProgramPageConfig(
  program,
  serverConfig,
  landingPageConfig,
  { primaryColor, colors },
) {
  const isSubscription = program.accessType === 'premium';
  const defaultConfig = isSubscription
    ? defaultSubscriptionPageConfig(program, {
        mainColor: primaryColor,
        landingPageConfig,
      })
    : defaultOTPPageConfig(program, {
        primaryColor,
        colors,
        landingPageConfig,
      });
  const res = {
    sections: extendSectionsType(defaultConfig.sections),
    ...serverConfig,
  };
  return res;
}

function parseProgramTestimonials(program) {
  if (!program.testimonials) return [];

  return program.testimonials.map((testimonial) => {
    return {
      name: testimonial.name,
      text: testimonial.text,
      image: toImgSrcRaw(testimonial.media),
      video: toVideoSrcRaw(testimonial.media),
    };
  });
}
